"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("../../styles");
var labelPlacement_1 = require("./utils/labelPlacement");
var sizeType_1 = require("./utils/sizeType");
var getPadding = function (spacing, checkboxPadding) { return (typeof checkboxPadding === 'number' ? spacing(checkboxPadding) : undefined); };
var useStyles = (0, styles_1.makeStyles)(function (_a) {
    var spacing = _a.spacing, typography = _a.typography;
    return ({
        checkboxRoot: {
            paddingTop: function (_a) {
                var _b = _a.checkboxPadding, checkboxPadding = _b === void 0 ? {} : _b;
                return getPadding(spacing, checkboxPadding.top);
            },
            marginRight: function (_a) {
                var label = _a.label, fullWidth = _a.fullWidth, labelPlacement = _a.labelPlacement;
                if ((fullWidth && (0, labelPlacement_1.checkIsStartLabelPlacement)(labelPlacement)) || !label)
                    return 0;
                if (label)
                    return spacing();
                return undefined;
            },
            paddingRight: function (_a) {
                var _b = _a.checkboxPadding, checkboxPadding = _b === void 0 ? {} : _b;
                return getPadding(spacing, checkboxPadding.right);
            },
            paddingBottom: function (_a) {
                var _b = _a.checkboxPadding, checkboxPadding = _b === void 0 ? {} : _b;
                return getPadding(spacing, checkboxPadding.bottom);
            },
            paddingLeft: function (_a) {
                var _b = _a.checkboxPadding, checkboxPadding = _b === void 0 ? {} : _b;
                return getPadding(spacing, checkboxPadding.left);
            }
        },
        label: {
            userSelect: 'none',
            fontSize: function (_a) {
                var size = _a.size;
                return ((0, sizeType_1.checkIsSmallSizeType)(size) ? typography.caption.fontSize : undefined);
            }
        },
        labelRoot: {
            marginLeft: function (_a) {
                var label = _a.label, labelPlacement = _a.labelPlacement;
                if (!label || (0, labelPlacement_1.checkIsStartLabelPlacement)(labelPlacement))
                    return 0;
                return undefined;
            },
            marginRight: function (_a) {
                var label = _a.label, labelPlacement = _a.labelPlacement;
                if ((0, labelPlacement_1.checkIsStartLabelPlacement)(labelPlacement))
                    return 0;
                if (!label)
                    return spacing(1);
                return undefined;
            },
            width: function (_a) {
                var fullWidth = _a.fullWidth;
                return (fullWidth ? '100%' : undefined);
            },
            justifyContent: function (_a) {
                var fullWidth = _a.fullWidth, labelPlacement = _a.labelPlacement;
                return (fullWidth && (0, labelPlacement_1.checkIsStartLabelPlacement)(labelPlacement) ? 'space-between' : undefined);
            }
        }
    });
});
exports.default = useStyles;
